import { Outlet } from "react-router-dom";

/*
  Later you can add:
  <AdminHeader />
  <AdminSidebar />
*/

const AdminLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AdminLayout;
